import { FC } from "react";
import st from './activityCard.module.scss';
import Heading from "../../../../components/heading/Heading";
import cn from "classnames";

interface ActivityCardProps {
    heading: string
    directionsCount: JSX.Element
    text?: JSX.Element
    determinedIndicators: string[]
    type: string
    image: JSX.Element
}

const ActivityCard: FC<ActivityCardProps> = ({heading, directionsCount, text, determinedIndicators, type, image}) => {
    return (
        <div className={cn(st['activity-card'], st[`activity-card--${type}`])}>
            <header className={st['activity-card__header']}>
                <Heading.Card>{heading}</Heading.Card>
                <div className={st['chips']}>{directionsCount}</div>
            </header>
            {text}
            <div className={st['activity-card__indicators']}>
                <Heading.CardSubHeading>{'Определяемые показатели'}</Heading.CardSubHeading>
                <ul className={st['list']}>
                    {determinedIndicators.map(indicator => <li className={st['list__item']}>{indicator}</li>)}
                </ul>
            </div>
            {image}
        </div>
    );
};

export default ActivityCard;